module.exports = __webpack_public_path__ + "media/images/avatars/null_female-71f518ae610c78ba668e2853cd832fb3.png";